import { Button, MagellanPopup } from 'components/atoms';
import ReleaseTypeSelectCard from 'components/molecules/card/release-type-select/ReleaseTypeSelectCard';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { RELEASE_TYPE } from 'services/music-product-digital/types/enums';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IReleaseTypeSelectPopupFormProps {
  trigger?: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  onSelectReleaseType?: (releaseType: RELEASE_TYPE | null, actions: PopupActions) => void;
  open?: boolean;
  initialReleaseType?: RELEASE_TYPE | null;
  displayMode?: boolean;
}

const ReleaseTypeSelectPopupForm = ({
  trigger,
  onSelectReleaseType,
  open,
  initialReleaseType = null,
  displayMode,
}: IReleaseTypeSelectPopupFormProps) => {
  const popupRef = useRef<PopupActions | null>(null);
  const { t } = useTranslation();

  const [releaseTypeSearch, setReleaseTypeSearch] = useState('');
  const [selectedReleaseType, setSelectedReleaseType] = useState<RELEASE_TYPE | null>(null);

  return displayMode ? (
    <>{trigger}</>
  ) : (
    <Popup
      ref={popupRef}
      open={open}
      onOpen={() => {
        setSelectedReleaseType(initialReleaseType);
      }}
      onClose={() => {
        setSelectedReleaseType(null);
        setReleaseTypeSearch('');
      }}
      modal
      nested
      trigger={trigger}
    >
      <MagellanPopup>
        <MagellanPopup.Header>{t('input.label.releaseType')}</MagellanPopup.Header>

        {/* <Input.Text
          value={releaseTypeSearch}
          onChange={(e) => setSelectedReleaseType(e.target.value)}
          name=""
          appBackground
          placeholder={t('input.placeholder.search-releaseType')}
        /> */}
        <div className="flex flex-col w-full max-w-96 overflow-auto h-[450px] [scrollbar-width:none]  gap-2">
          {Object.values(RELEASE_TYPE)
            .filter((releaseType) => typeof releaseType === 'string' && releaseType !== 'unknown')
            .filter((releaseType) =>
              t(`release-type.${releaseType}.name`)
                .toLowerCase()
                .includes(releaseTypeSearch.toLowerCase()),
            )
            .map((releaseType) => {
              const convertedReleaseType = RELEASE_TYPE[releaseType as keyof typeof RELEASE_TYPE];
              return (
                <ReleaseTypeSelectCard
                  key={convertedReleaseType}
                  releaseType={convertedReleaseType}
                  isSelected={selectedReleaseType === convertedReleaseType}
                  onClick={(newReleaseType) =>
                    setSelectedReleaseType((prev) =>
                      prev === newReleaseType ? null : newReleaseType,
                    )
                  }
                />
              );
            })}
        </div>
        <div className="flex justify-between w-full">
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t('button.cancel')} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            onClick={() =>
              popupRef.current &&
              onSelectReleaseType &&
              onSelectReleaseType(selectedReleaseType, popupRef.current)
            }
          >
            <Button.Text text={t('button.save')} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default ReleaseTypeSelectPopupForm;
